@if (uploadFieldsProgress().length) {
  <div class="wrapper">
    <div class="form-header-uploads">
      <procure-card condensed>
        <div class="container">
          <div class="block">
            <div class="header">
              <h2 class="title">File Upload Progress</h2>
            </div>
            <div class="uploads">
              @for (uploadField of uploadFieldsProgress(); track uploadField.key) {
                <div class="file-upload">
                  <span>{{ uploadField.key }}</span>
                  <mat-progress-bar
                    class="progress"
                    mode="determinate"
                    [value]="uploadField.completed ? 100 : uploadField.progress"
                  />
                </div>
              }
            </div>
          </div>
          <div class="block scanning">
            <div class="header">
              <img
                class="defender"
                alt="Microsoft Defender Logo"
                [src]="'/assets/icons/Security-Center.svg' | fileHash"
              />
              <h2 class="title">File Scanning Progress</h2>
            </div>
            <div class="uploads">
              @for (uploadField of uploadFieldsProgress(); track uploadField.key) {
                <div class="file-upload">
                  <span>{{ uploadField.key }}</span>
                  <mat-progress-bar
                    class="progress"
                    mode="determinate"
                    color="green"
                    [value]="scanProgress()[uploadField.id]"
                  />
                </div>
              }
            </div>
          </div>
        </div>
      </procure-card>
    </div>
  </div>
}
